import {
  Box,
  Grid,
  LinearProgress,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import SimpleAlert from "../../../components/display/SimpleAlert";
import PageContentWrapper from "../../../components/wrappers/PageContentWrapper";
import { GET_BOXES } from "../../../enums/ApiPaths";
import { BOXES_LIST_KEY } from "../../../enums/QueryKeys";
import { useFetch } from "../../../hooks/Fetching";
import useUser from "../../../hooks/useUser";
import SingleBoxCard from "../components/cards/SingleBoxCard";
import NotFound from "../components/display/NotFound";
import AddBox from "../components/forms/AddBox";
import ActiveTherapiesTable from "./ActiveTherapiesTable";
import { TabPanel } from "./single/SinglePetView";

const BoxesList = () => {
  const { roles, currentClinic } = useUser();
  const { t } = useTranslation();
  const url = GET_BOXES;
  const clinciId = currentClinic.id;
  const id = roles.master ? null : clinciId;
  const { data, isLoading, error } = useFetch(url, id, BOXES_LIST_KEY);
  const [activeTab, setActiveTab] = React.useState(0);

  return (
    <PageContentWrapper noSideMargin={true} sideMargin={5}>
      <Box sx={{ mb: 6, textAlign: "left" }}>
        <Title title={t("Stationary")} />
      </Box>

      <Tabs
        value={activeTab}
        onChange={(_, newValue) => setActiveTab(newValue)}
        sx={{ mb: 3 }}
      >
        <Tab label={t("Boxes")} />
        <Tab label={t("ActiveTherapies")} />
      </Tabs>

      <TabPanel value={activeTab} index={0}>
        <Box mb={2}>
          <AddBox />
        </Box>
        <Data data={data} isLoading={isLoading} error={error} />
      </TabPanel>

      <TabPanel value={activeTab} index={1}>
        <ActiveTherapiesTable />
      </TabPanel>
    </PageContentWrapper>
  );
};

export default BoxesList;

function Data({ data = [], isLoading = false, error }) {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <Grid item xs={12} key={"loading-grid"}>
        <LinearProgress />
      </Grid>
    );
  } else if (error && !isLoading) {
    return (
      <SimpleAlert message={"ErrorFetchingBoxesList"} severity={"error"} />
    );
  }

  if (!data || !Array.isArray(data) || data.length == 0) {
    return <NotFound title={t("NoBoxesYet")} subtitle={t("AddFirstBox")} />;
  }
  return (
    <Grid container spacing={2}>
      {data.map((box, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={box.id}>
          <SingleBoxCard box={box} index={index} />
        </Grid>
      ))}
    </Grid>
  );
}

function Title({ title = "" }) {
  const { t } = useTranslation();
  return (
    <Typography
      variant="h3"
      gutterBottom
      sx={{
        fontWeight: 800,
        mb: 2,
      }}
    >
      {t(title)}
    </Typography>
  );
}
